import { useIntl } from 'react-intl';

import { ImagePlaceholder } from '@/components/ImagePlaceholder';
import { Modal } from '@/components/Modal';
import { Typography } from '@/components/Typography';
import { commonMessages } from '@/messages/common';

import { SocialButtons } from '../SocialButtons';

import * as S from './ShareModal.styles';
export type ProductShareModalProps = {
  isOpen: boolean;
  onClose: (event?: Event) => void;
  shareableProductData: Record<PropertyKey, string | null | undefined>;
};

export const ShareModal = ({
  isOpen,
  onClose,
  shareableProductData,
}: ProductShareModalProps) => {
  const { formatMessage } = useIntl();
  const { collection, description, image, name, url } =
    shareableProductData || {};

  const title = collection ? `${collection} ${name}` : `${name}`;
  const subject = `${formatMessage(commonMessages.shareEmailCheckout)} ${name}`;

  return (
    <Modal isOpen={isOpen} onClose={onClose} width='100%'>
      <Modal.Header onClose={onClose}>Share</Modal.Header>
      <Modal.Body>
        <S.Wrapper $maxWidth='sm'>
          <S.ImageContainer>
            {image ? (
              <S.ProductImage alt='subTitle' src={image} />
            ) : (
              <ImagePlaceholder />
            )}
          </S.ImageContainer>
          <S.ProductDescription $maxWidth='sm'>
            <S.Heading scale='h5'>
              {collection && (
                <S.Collection as='span' color='primary'>
                  {`${collection} `}
                </S.Collection>
              )}
              {name}
            </S.Heading>
            {description && <Typography>{description}</Typography>}
            {url && <SocialButtons subject={subject} title={title} url={url} />}
          </S.ProductDescription>
        </S.Wrapper>
      </Modal.Body>
    </Modal>
  );
};

ShareModal.displayName = 'ShareModal';
